import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserRole } from '@/types';

interface AuthState {
  userId: string | null;
  email: string | null;
  username: string | null;
  role: UserRole | null;
  points: number;
  paidCoins: number;
  freeCoins: number;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (userId: string, email: string, username: string, role: UserRole) => void;
  logout: () => void;
  setLoading: (loading: boolean) => void;
  setPoints: (points: number) => void;
  setCoins: (paidCoins: number, freeCoins: number) => void;
  totalCoins: () => number;
  isAdmin: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      userId: null,
      email: null,
      username: null,
      role: null,
      points: 0,
      paidCoins: 0,
      freeCoins: 0,
      isAuthenticated: false,
      isLoading: true,
      login: (userId, email, username, role) =>
        set({
          userId,
          email,
          username,
          role,
          isAuthenticated: true,
          isLoading: false,
        }),
      logout: () =>
        set({
          userId: null,
          email: null,
          username: null,
          role: null,
          points: 0,
          paidCoins: 0,
          freeCoins: 0,
          isAuthenticated: false,
          isLoading: false,
        }),
      setLoading: (loading) => set({ isLoading: loading }),
      setPoints: (points) => set({ points }),
      setCoins: (paidCoins, freeCoins) => set({ paidCoins, freeCoins }),
      totalCoins: () => {
        const state = get();
        return state.paidCoins + state.freeCoins;
      },
      isAdmin: () => {
        const state = get();
        return state.role === 'admin' || state.role === 'super-admin';
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
